import '.a{display:grid;}.ssr-plugin'
import '.c{gap:1.5rem;}.ssr-plugin'
import '.go{grid-template-columns:repeat(2, 1fr);}.ssr-plugin'
import { InitiativeCard } from '@app/components/blocks/card/InitiativeCard'
import { styled } from 'inlines'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { useTranslations } from '@i18n/useLanguage'
import { ViewTopicCommunityModel } from 'functions/app/topic-community/view'
import { pages } from '@app/util/links'
import { labelAddressBuilder } from '@app/util/helpers'

export const TopicCommunityPageInitiatives = ({
  topicCommunity,
}: {
  topicCommunity: ViewTopicCommunityModel
}) => {
  const t = useTranslations().app
  const initiatives = topicCommunity?.relatedInitiatives ?? []

  return (
    <styled.div className="a c go"
      style={{
        '@media (max-width: 1200px)': {
          gridTemplateColumns: '1fr',
        },
      }}
    >
      {initiatives.map((initiative) => (
        <InitiativeCard
          key={initiative.id}
          to={pages.initiative(initiative.slug)}
          image={initiative.images?.[0]?.src ?? defaultProjectPicture}
          title={initiative.title}
          description={initiative.description}
          location={labelAddressBuilder(
            initiative.location?.address,
            t.common.notSpecified,
          )}
          phase={initiative.phase?.name}
          tagText={
            initiative.searchingForMembers
              ? t.common.initiativeStatus.searchingForMembers
              : t.common.initiativeStatus.notSearchingForMembers
          }
          tagVariant={initiative.searchingForMembers ? 'success' : 'neutral'}
        />
      ))}
    </styled.div>
  )
}
